import cn from 'classnames'
import React, { ComponentProps } from 'react'

type CardIconSVGProps = ComponentProps<'svg'>

export default function CardIconSVG(props: CardIconSVGProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('CardIconSVG', className)}
      width="110"
      height="74"
      viewBox="0 0 110 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g filter="url(#filter0_d_1717_9992)">
        <path
          d="M100.597 3.5L9.40252 3.5C6.97107 3.5 5 5.47107 5 7.90252L5 62.0975C5 64.5289 6.97107 66.5 9.40252 66.5H100.597C103.029 66.5 105 64.5289 105 62.0975V7.90252C105 5.47107 103.029 3.5 100.597 3.5Z"
          fill="black"
        />
      </g>
      <path
        d="M100.597 3.5L9.40252 3.5C6.97107 3.5 5 5.47107 5 7.90252L5 62.0975C5 64.5289 6.97107 66.5 9.40252 66.5H100.597C103.029 66.5 105 64.5289 105 62.0975V7.90252C105 5.47107 103.029 3.5 100.597 3.5Z"
        fill="#4488F8"
      />
      <path
        opacity="0.5"
        d="M23.661 9.5H15.5728C14.2419 9.5 13.1631 10.5789 13.1631 11.9097V19.2245C13.1631 20.5553 14.2419 21.6342 15.5728 21.6342H23.661C24.9918 21.6342 26.0707 20.5553 26.0707 19.2245V11.9097C26.0707 10.5789 24.9918 9.5 23.661 9.5Z"
        fill="#FCFFFF"
      />
      <path
        d="M17.6972 13.8682H8.62893C8.28158 13.8682 8 14.1497 8 14.4971V17.1222C8 17.4695 8.28158 17.7511 8.62893 17.7511H17.6972C18.0445 17.7511 18.3261 17.4695 18.3261 17.1222V14.4971C18.3261 14.1497 18.0445 13.8682 17.6972 13.8682Z"
        fill="#4488F8"
      />
      <path
        d="M30.6048 13.8682H21.5366C21.1892 13.8682 20.9077 14.1497 20.9077 14.4971V17.1222C20.9077 17.4695 21.1892 17.7511 21.5366 17.7511H30.6048C30.9522 17.7511 31.2337 17.4695 31.2337 17.1222V14.4971C31.2337 14.1497 30.9522 13.8682 30.6048 13.8682Z"
        fill="#4488F8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.0289 33.0889H13.7193C13.1204 33.0889 12.635 33.5744 12.635 34.1732V35.7176C12.635 36.3164 13.1204 36.8019 13.7193 36.8019H70.0289C70.6277 36.8019 71.1132 36.3164 71.1132 35.7176V34.1732C71.1132 33.5744 70.6277 33.0889 70.0289 33.0889Z"
        fill="url(#paint0_linear_1717_9992)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.2462 44.0098L13.7193 44.0098C13.1204 44.0098 12.6349 44.4953 12.6349 45.0941V46.6385C12.6349 47.2373 13.1204 47.7228 13.7193 47.7228L85.2462 47.7228C85.8451 47.7228 86.3306 47.2373 86.3306 46.6385V45.0941C86.3306 44.4953 85.8451 44.0098 85.2462 44.0098Z"
        fill="url(#paint1_linear_1717_9992)"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.2463 54.9307H13.7193C13.1205 54.9307 12.635 55.4161 12.635 56.015V57.5594C12.635 58.1582 13.1205 58.6437 13.7193 58.6437H35.2463C35.8451 58.6437 36.3306 58.1582 36.3306 57.5594V56.015C36.3306 55.4161 35.8451 54.9307 35.2463 54.9307Z"
        fill="url(#paint2_linear_1717_9992)"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.2897 54.9307H51.7628C51.1639 54.9307 50.6784 55.4161 50.6784 56.015V57.5594C50.6784 58.1582 51.1639 58.6437 51.7628 58.6437H73.2897C73.8886 58.6437 74.3741 58.1582 74.3741 57.5594V56.015C74.3741 55.4161 73.8886 54.9307 73.2897 54.9307Z"
        fill="url(#paint3_linear_1717_9992)"
      />
      <defs>
        <filter
          id="filter0_d_1717_9992"
          x="0"
          y="0.5"
          width="110"
          height="73"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1717_9992"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1717_9992"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1717_9992"
          x1="56.3858"
          y1="34.9454"
          x2="25.1834"
          y2="34.9454"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D0E2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1717_9992"
          x1="67.7707"
          y1="45.8663"
          x2="28.4487"
          y2="45.8663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D0E2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1717_9992"
          x1="30.363"
          y1="56.7872"
          x2="17.7196"
          y2="56.7872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4EEFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1717_9992"
          x1="68.4065"
          y1="56.7872"
          x2="55.7631"
          y2="56.7872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4EEFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  )
}
